import { Component, OnInit, ViewChild } from '@angular/core';
import { MatTableDataSource, MatPaginator, MatSort,DateAdapter, MAT_DATE_LOCALE, MAT_DATE_FORMATS } from '@angular/material';
import { DatePipe } from "@angular/common";
import Swal from "sweetalert2";
import { MomentDateAdapter } from "@angular/material-moment-adapter";
import { MessagesTitles, MessagesGeneral, MessagesDates } from '../../../models/messages';
import { Operacion } from 'app/models/Operacion';
import { OperacionDetalle } from '../../../models/OperacionDetalle';
import { OperacionService } from '../../../services/operaciones/operacion/operacion.service';
import { environment } from 'environments/environment';

export const MY_FORMATS = {
    parse: {
      dateInput: "DD-MM-YYYY"
    },
    display: {
      dateInput: "DD-MM-YYYY",
      monthYearLabel: "MMM YYYY",
      dateA11yLabel: "LL",
      monthYearA11yLabel: "MMMM YYYY"
    }
  };

  declare var $: any;
@Component({
  selector: 'app-nuevo-solicitud-des',
  templateUrl: './nuevo-solicitud-des.component.html',
  styleUrls: ['./nuevo-solicitud-des.component.scss'],
  providers: [MessagesTitles,MessagesGeneral,MessagesDates,Operacion,
    DatePipe,
  
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE]
    },

    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS }
  ]
})
export class NuevoSolicitudDesComponent implements OnInit {

  Label_Proveedor=environment.LABEL_PROVEEDOR;
  Label_Proveedores=environment.LABEL_PROVEEDORES;
  Label_Adquirente=environment.LABEL_ADQUIRENTE;
  Label_Adquirentes=environment.LABEL_ADQUIRENTES;
  Label_id_soles=environment.ID_GUIA_SOLES;
  Label_id_dolares=environment.ID_GUIA_DOLARES
  Operacion : any = [];
  check0: boolean = false;
  soliDesDetalle : OperacionDetalle[] = [];
  idOperacion : number =0;
  contratoTotal = [];
  tipoMoneda:string = "1";
  estado ="P";
  idProv ="" ;
  idAdq ="";
  value = '';
  SolicitudDesGeneral: any = [];
  operacion:Operacion;
  flag:boolean = false;
  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;  
  @ViewChild(MatSort, {static: true}) sort: MatSort;
  pageSizeOptions = [10,20,30,50,100,200];
  loading:boolean=false;
  displayedColumns: string[] = ['checked','idOperacion','Fecha_Operacion','pRazonSocial','aRazonSocial','Alta_Fecha','Moneda','VNPP','Adelanto_porcentaje',
  'Adelanto_importe','Tasa_Mensual','Remanente_importe','Adelanto_Ejecutado_importe','Adelanto_Pendiente_importe','Adelanto_Vencido_Importe','Estado']
  dataSource :any;

  constructor(private operacionService:OperacionService){}
  applyFilter(filterValue: string) {
    if(null != this.dataSource){
       this.dataSource.filter = filterValue.trim().toLowerCase();
    }
  }

  ngOnInit(){
    this.ListadoOperacionFiltro();
  }

  ListadoOperacionFiltro(){
    this.SolicitudDesGeneral = [];
      this.loading = true;
      this.operacionService.obtenerOperacionSoliDes()
      .subscribe(
        res=>{
          this.Operacion = res;
          console.log(this.Operacion);
          if(this.tipoMoneda === "0"){
            this.Operacion = this.Operacion.filter(object => object.Moneda == this.Label_id_soles); 
          } else {
            this.Operacion = this.Operacion.filter(object => object.Moneda == this.Label_id_dolares); 
          } 
          this.dataSource = new MatTableDataSource(this.Operacion);
          this.dataSource.sort = this.sort;
          this.dataSource.paginator = this.paginator;
          this.loading = false;
        }, err =>{
          Swal.fire({
            title:"¡Algo salió mal!",
            text: err.error['error'],
            type:"warning",
            allowOutsideClick: true,
            heightAuto: false
          });
          this.loading = false;
        }
      )
  }


  Agregar(element: any){
    if(element.checked){
      this.SolicitudDesGeneral.push(element);        
    }else{          
       this.SolicitudDesGeneral = this.SolicitudDesGeneral.filter(function(dato){
         if (dato.idOperacion == element['idOperacion']) {
           return false;
         } else {
           return true;
         }
       })
    }  
  }

  openForm(){
    if(this.SolicitudDesGeneral.length == 0){
      Swal.fire({
        title: 'Atención!',
        text: 'No se han selecionado registros.',
        type: 'info',
        heightAuto: false
    })
    } else {
      this.flag = true;
    }
  }

  CerrarVentana(){
    this.flag = false;
  }


  limpiar(){
    this.SolicitudDesGeneral = [];
    this.Operacion.map(object => object.checked = false);
  }

  showNotification(type,from,align,message){
    $.notify({
        icon: "notifications",
        message: message
    },{
        type: type,
        timer: 4000,
        placement: {
            from: from,
            align: align
        },
        template: '<div data-notify="container" class="col-xl-4 col-lg-4 col-11 col-sm-4 col-md-4 alert alert-{0} alert-with-icon" role="alert">' +
          '<button mat-button  type="button" aria-hidden="true" class="close mat-button" data-notify="dismiss">  <i class="material-icons">close</i></button>' +
          '<i class="material-icons" data-notify="icon">notifications</i> ' +
          '<span data-notify="title">{1}</span> ' +
          '<span data-notify="message">{2}</span>' +
          '<div class="progress" data-notify="progressbar">' +
            '<div class="progress-bar progress-bar-{0}" role="progressbar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100" style="width: 0%;"></div>' +
          '</div>' +
          '<a href="{3}" target="{4}" data-notify="url"></a>' +
        '</div>'
    });
  }

}

